import { Alert } from '@mui/material';
import { format, parseISO } from 'date-fns';
import React from 'react'
import { formatTime } from 'src/coach/service/coach.utils';
import ClassCard from './class-card';

const ConflictListing = ({timeOff,conflicts,showConfirmText}) => {
  const dateRange = `${format(
    parseISO(timeOff.startDate),
    'MM/dd/yyy',
  )} - ${format(parseISO(timeOff.endDate), 'MM/dd/yyy')}`;
  const timeRange =
  timeOff.startTime === '00:00' && timeOff.endTime === '23:59'
    ? 'All Day'
    : `${formatTime(timeOff.startTime)} - ${formatTime(timeOff.endTime)}`;
  const groupedConflicts = conflicts.reduce((acc, conflict) => {
  const conflictDate =format(
			new Date(conflict.startDateTimeInUTC),
			"EE, MM/dd/yyyy",
		);


  if (!acc[conflictDate]) {
    acc[conflictDate] = [];
  }

  acc[conflictDate].push(conflict);

  return acc;
}, {});

const groupedConflictsArray = Object.entries(groupedConflicts).map(([date, conflicts]) => ({
  date,
  conflicts,
}));

  return (
   <div>
  <div className="tw-sticky tw-top-0 tw-left-0 tw-w-full tw-z-10 tw-shadow-md">
    <Alert severity="error" className="tw-bg-[#ffdee4] tw-text-red">
      <div>
        You are staffed to the following classes during your time off request for{" "}
        <span className="tw-font-bold">{dateRange}</span>,{" "}
       <span className="tw-font-bold">{timeRange}</span>. {showConfirmText && "Please confirm if you want to continue."}
      </div>
    </Alert>
  </div>

  <div className="tw-p-3">
    {groupedConflictsArray.map((group, index) => (
      <div key={index}>
        <span>
          <span className="tw-font-bold tw-text-[16px] tw-text-black tw-mr-2">{group.date}</span>
          <span>({group.conflicts.length} conflicts)</span>
        </span>
        <div className="tw-mt-2">
          <ClassCard eventDates={group.conflicts} />
        </div>
      </div>
    ))}
  </div>
</div>

  )
}

export default ConflictListing